module.exports = __webpack_public_path__ + "img/heart1.4ad057de.png";